import { gql } from '@apollo/client'

export const GET_REVENUE_DASHBOARD = gql`
    query GetRevenueDashboard($period: REVENUE_PERIOD, $dateRange: DateRangeInput, $routeType: RouteType) {
        getRevenueDashboard(period: $period, date_range: $dateRange, route_type: $routeType) {
            code
            success
            message
            revenue_dashboard {
                gross_revenue
                net_revenue
                wallet_refunds
                wallet_spend
                std_net_revenue
                day_pass_net_revenue
                gross_vip_seat_revenue
                gross_std_seat_revenue
                std_bookings
                day_pass_bookings
                daypass_std_bookings
                std_cancellations
                passenger_transported
                charter_boat_net_revenue
                charter_boat_bookings
                station_revenues {
                    station_id
                    station_name {
                        en
                        ar
                    }
                    start_station_total_bookings
                    start_station_total_passengers
                    start_station_gross_revenue
                    start_station_total_discounts
                    start_station_net_revenue
                    end_station_total_bookings
                    end_station_total_passengers
                    end_station_gross_revenue
                    end_station_total_discounts
                    end_station_net_revenue
                }
                payment_method_revenues {
                    payment_method
                    revenue_percentage
                }
                route_revenues {
                    route_id
                    route_name {
                        en
                        ar
                    }
                    net_revenue
                }
                captain_revenues {
                    captain_id
                    captain_name
                    total_revenue
                    trips_completed
                }
                boat_revenues {
                    boat_id
                    boat_name {
                        en
                        ar
                    }
                    total_revenue
                    avg_trip_value
                }
            }
        }
    }
`

export const GET_EXECUTIVE_DASHBOARD = gql`
    query getExecutiveDashboard($period: REVENUE_PERIOD, $date_range: DateRangeInput, $route_type: RouteType) {
        getExecutiveDashboard(period: $period, date_range: $date_range, route_type: $route_type) {
            code
            success
            message
            executive_dashboard {
                total_bookings
                total_std_bookings
                total_daypass_bookings
                total_passengers
                total_scheduled_trips
                trips_completed
                trips_cancelled
                booking_distribution {
                    period_label
                    std_booking_count
                    daypass_count
                }
                passengers_distribution {
                    period_label
                    passengers_count
                }
                station_bookings {
                    station_id
                    station_name {
                        en
                        ar
                    }
                    booking_count
                }
                passenger_type_counts {
                    infant_count
                    child_count
                    adult_count
                    senior_count
                    total_passengers
                }
                route_performance {
                    master_route_id
                    route_name {
                        en
                        ar
                    }
                    total_bookings
                    total_passengers
                    net_revenue
                    trips_completed
                    trips_cancelled
                }
                most_profit_route {
                    master_route_id
                    route_name {
                        en
                        ar
                    }
                    value
                }
                highest_demand_route {
                    master_route_id
                    route_name {
                        en
                        ar
                    }
                    value
                }
                lowest_demand_route {
                    master_route_id
                    route_name {
                        en
                        ar
                    }
                    value
                }
                customer_rating
                complaint_rate
                station_details {
                    station_id
                    station_name {
                        en
                        ar
                    }
                    booking_count
                    passengers_count
                    revenue
                    trip_count
                }
                std_net_revenue
                day_pass_net_revenue
                hourly_booking_trends {
                    booking_hour
                    booking_hour_label
                    booking_count
                }
                net_revenue
                top_routes_by_bookings {
                    master_route_id
                    route_name {
                        en
                        ar
                    }
                    pass_count
                }
                payment_method_revenues {
                    payment_method
                    revenue_percentage
                }
                vip_net_revenue
            }
        }
    }
`
